import { render, staticRenderFns } from "./StepType.vue?vue&type=template&id=6065bc46&scoped=true&"
import script from "./StepType.vue?vue&type=script&lang=js&"
export * from "./StepType.vue?vue&type=script&lang=js&"
import style0 from "./StepType.vue?vue&type=style&index=0&id=6065bc46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065bc46",
  null
  
)

export default component.exports